<app-selector
  label="Racing Game"
  [isEmptySelectable]="isEmptySelectable"
  [data]="racingGameCoreService.racingGameList$ | async"
  displayKey="name"
  [formControl]="ctrl"
  (refreshEvent)="refresh()"
  hintStyle="margin-left: -14px; margin-top: -5px"
  [loading]="racingGameCoreService.loading$ | async"
  [hint]="hint"
>
</app-selector>
